import styled from "styled-components";

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
`;

export const Title = styled.h2`
  margin: 0;

  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor} !important;
`;

export const SubTitle = styled.h4`
  margin: 0.25rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${(props) =>
    props.theme?.checkoutStepsOffers?.placeholderColor} !important;
`;
